import React from 'react';
// Modules
import Pagination from 'react-bootstrap/Pagination';
// Icons
import { BsChevronBarLeft, BsArrowLeft, BsArrowRight, BsChevronBarRight } from 'react-icons/bs';

const Pager = ({ currentPage, totalPages, onPageChange }) => {
  const pagesToShow = 5;
  const pages = [];

  const handleClick = (page) => {
    if (page >= 1 && page <= totalPages) {
      onPageChange(page);
    }
  };

  const renderPageItem = (page) => (
    <Pagination.Item key={page} active={page === currentPage} onClick={() => handleClick(page)}>
      {page}
    </Pagination.Item>
  );

  if (currentPage > 1) {
    pages.push(
      <div key="first" className="pagination--arrow" onClick={() => handleClick(1)}>
        <BsChevronBarLeft />
      </div>
    );
    pages.push(
      <div key="prev" className="pagination--arrow" onClick={() => handleClick(currentPage - 1)}>
        <BsArrowLeft />
      </div>
    );
  }

  if (currentPage > pagesToShow) {
    pages.push(<Pagination.Ellipsis key="ellipsis-start" />);
  }

  const startPage = Math.max(1, currentPage - Math.floor(pagesToShow / 2));
  const endPage = Math.min(totalPages, startPage + pagesToShow - 1);

  for (let i = startPage; i <= endPage; i++) {
    pages.push(renderPageItem(i));
  }

  if (endPage < totalPages) {
    pages.push(<Pagination.Ellipsis key="ellipsis-end" />);
  }

  if (currentPage < totalPages) {
    pages.push(
      <div key="next" className="pagination--arrow" onClick={() => handleClick(currentPage + 1)}>
        <BsArrowRight />
      </div>
    );

    pages.push(
      <div key="last" className="pagination--arrow" onClick={() => handleClick(totalPages)}>
        <BsChevronBarRight />
      </div>
    );
  }

  return totalPages > 1 && <Pagination className="justify-content-end">{pages}</Pagination>;
};

export default Pager;
